import { supabase } from "../../supabaseClient";

const toNullable = (value) => {
  if (value === undefined || value === null) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  return value;
};

export const addFollower = async (followerData) => {
  if (!supabase) {
    throw new Error(
      "Supabase não configurado: defina REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY"
    );
  }

  const hasCpf = followerData.cpf && followerData.cpf.trim() !== "";

  // Toda a escrita passa pelo RPC SECURITY DEFINER `subscribe_follower`.
  // O cliente anon não tem mais INSERT/UPDATE direto na tabela followers,
  // então não há como reescrever/ler registros arbitrários com a anon key.
  const { data, error } = await supabase.rpc("subscribe_follower", {
    p_full_name: followerData.fullName,
    p_preferred_contact: followerData.preferredContact,
    p_cpf: hasCpf ? followerData.cpf : null,
    p_email: toNullable(followerData.email),
    p_phone: toNullable(followerData.phone),
    p_city_state: toNullable(followerData.cityState),
    p_attended_event: followerData.attendedEvent || false,
    p_extra_data: {
      instagram: toNullable(followerData.instagram),
      birthDate: toNullable(followerData.birthDate),
      nationality: toNullable(followerData.nationality),
      ...followerData.utmParams,
    },
  });

  if (error) throw error;

  return { ok: true, isNew: data?.isNew ?? true };
};
